import styled from 'styled-components'

import { Layout } from '@loadsmart/miranda-react'
import { toCSSValue } from '@loadsmart/miranda-react/dist/tokens'

import { isEmpty } from 'core/utils/array'

import type { TrackingMethod, TrackingProvider } from '../../domain/Tracking'
import { getMethodIcon, getProviderIcon } from './trackingIconsUtils'

const ProviderBox = styled(Layout.Box).attrs({
  backgroundColor: 'color-background-primary',
  padding: 'none',
  borderRadius: 'border-radius-s',
  paddingX: 'spacing-2',
})`
  height: 28px;
  display: flex;
  min-width: 28px;
  align-items: center;
  justify-content: center;
  padding-inline: 6px;
  box-shadow: ${toCSSValue('elevation-1')};
`

type ProvidersBadgeProps = {
  readonly methods?: TrackingMethod[]
  readonly providers?: TrackingProvider[]
}

export function ProvidersBadge({ methods, providers }: ProvidersBadgeProps) {
  return (
    <Layout.Group gap="spacing-3" align="center">
      <ProviderBox>
        <Layout.Group gap="spacing-2">
          {!isEmpty<string[]>(methods) && methods?.map(method => getMethodIcon(method))}
          {!isEmpty<string[]>(providers) && providers?.map(getProviderIcon)}
        </Layout.Group>
      </ProviderBox>
    </Layout.Group>
  )
}
